import '../../../App.css';
import { MenuItem, Menu, Typography, Button } from '@mui/material';
import { Box, useMediaQuery } from "@mui/material";
import LogoutWidget from "../Logout";
import { Link } from 'react-router-dom';
import fetchAdminReports from '../helper-methods/fetchAdminReports';
import React, { useEffect } from 'react';

const HeaderProfileSettings = ({ anchorEl, handleCloseMenu, isLoggedIn, setIsLoggedIn, isAdmin
}) => {
    const isMobile = useMediaQuery('(max-width:1300px)');

    return (
        <Box>
            {/* 2. The Actual Menu: This stays hidden until anchorEl is set */}
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl) && anchorEl.id === 'profile-button'}
                onClose={handleCloseMenu}
                onClick={handleCloseMenu}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <MenuItem>
                    <Typography variant="h6" className={isLoggedIn ? "" : "hidden"} sx={{ color: 'green', ml: 2 }}>
                        {localStorage.getItem('username') || ""}
                    </Typography>
                </MenuItem>
                <MenuItem>

                    <Button
                        id="loginButton"
                        variant="contained"
                        className={isLoggedIn ? '' : 'hidden'}
                        color="none"
                        component={Link}
                        to="/profile"
                        onclick={() => { }}
                        style={{ boxShadow: 'none' }}
                    >
                        Profile
                    </Button>
                </MenuItem>
                {isMobile ? (
                    <MenuItem sx={{ display: isAdmin ? 'flex' : 'none' }} component={Link} to="/adminPanel" onClick={handleCloseMenu}>
                        <Button
                            id="loginButton"
                            variant="contained"
                            color="none"
                            component={Link}
                            to="/adminPanel"
                            onclick={() => { }}
                            sx={{ boxShadow: 'none' }}
                        >
                            Admin panel
                        </Button></MenuItem>) : null}
                <MenuItem>
                    <LogoutWidget isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} />
                </MenuItem>

            </Menu>
        </Box>
    )
};

export default HeaderProfileSettings;